import toMillis from '../measurementSignals/toMillis'
import { submissionKey } from '../dataHelpers/countSubmissions'

// AI-CONTEXT: See docs/features/deep-analysis-period.md
// AI-CONTEXT: See docs/pitfalls.md#database-totaldocs-overcounts-respondents
//
// The core of the period filter, in epoch-ms bounds: keeps the whole
// submissions that started inside [startMs, endMs]. A filled-in questionnaire
// writes a document per question with slightly different timestamps, so it is
// grouped by the same key countSubmissions uses and dated by its earliest
// answer — it never lands half in one period and half in the next.
//
// Split from filterSubmissionsByPeriod (which takes ISO dates) because the
// server needs the same rule with the bounds it receives in ms; the CommonJS
// mirror in functions/utils/filterSubmissionsByMs.js is parity-pinned against
// THIS file.

/**
 * @param {Array<object>} records - QuestionnairesResponses documents
 * @param {{startMs: number, endMs: number}} bounds - Inclusive epoch-ms bounds
 * @returns {Array<object>} The records of the submissions that started inside the bounds
 */
export const filterSubmissionsByMs = (records, { startMs, endMs }) => {
    if (!Array.isArray(records)) return []
    const keys = records.map((r, i) => submissionKey(r, toMillis(r?.Timestamp), i))

    // Earliest answer per submission.
    const startedAt = new Map()
    records.forEach((r, i) => {
        const ms = toMillis(r?.Timestamp)
        if (ms === null) return
        const prev = startedAt.get(keys[i])
        if (prev === undefined || ms < prev) startedAt.set(keys[i], ms)
    })

    return records.filter((r, i) => {
        const ms = startedAt.get(keys[i])
        return ms !== undefined && ms >= startMs && ms <= endMs
    })
}

export default filterSubmissionsByMs
